/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Exec_HintInputs */

const en_inbox_exec_hint = /** @type {(inputs: Inbox_Exec_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How the builder works`)
};

const id_inbox_exec_hint = /** @type {(inputs: Inbox_Exec_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara kerja pembangun`)
};

/**
* | output |
* | --- |
* | "How the builder works" |
*
* @param {Inbox_Exec_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_exec_hint = /** @type {((inputs?: Inbox_Exec_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Exec_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_exec_hint(inputs)
	return en_inbox_exec_hint(inputs)
});